import React, { useEffect, useRef, useState } from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { HiDotsHorizontal, HiDotsVertical } from 'react-icons/hi';
import { MdDelete, MdDeleteOutline } from 'react-icons/md';
import { GrEdit, GrUpdate, GrView } from 'react-icons/gr';
import { TbPassword } from 'react-icons/tb';
import ViewUserModal from '../../Components/Modal/ViewUserModal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BsFillPencilFill, BsFillTrashFill } from 'react-icons/bs';
import Modal from 'react-modal';
import {
  api,
  apiBaseUrl,
  getUserById,
  getUsersAddedByAdmin,
} from '../../Api-Endpoints/apiEndpoint';
import { updateUserSuccess, userDeletedSuccess } from '../../Redux/UserSlice';
import toast from 'react-hot-toast';
import axios from 'axios';

import { IoMdCloseCircleOutline } from 'react-icons/io';
import DeleteModal from '../../Components/Modal/DeleteModal';
import UpdateUserModal from '../../Components/Modal/UpdateUserModal';
import { Dropdown } from 'antd';
import ApiHandler from '../../ApiHandler';
const UserTable = ({ isUser }) => {
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const { usersList, user, _roles } = useSelector(
    state => ({
      usersList: state.Users.users,
      user: state.Users.user,
      //  roles: state.Roles.roles,
      _roles: state.Roles._roles,
    }),
    shallowEqual
  );

  const getUserByAdmin = async () => {
    const data = localStorage.getItem('userInfo');
    if (data) {
      const user = JSON.parse(data);
      try {
        const res = await ApiHandler.getUsers(user?._id);
        setUsers(res?.users);
      } catch (error) {
        console.error('Failed to fetch users:', error);
      }
    }
  };

  useEffect(() => {
    getUserByAdmin();
  }, []);
  useEffect(() => {
    getUserByAdmin();
  }, [isUser]);

  const [SelectedUserIndex, setSelectedUserIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [openRoleCreate, setOpenRoleCreate] = useState(false);
  const [ids, setIds] = useState('');
  const [selectUser, setSelectUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState('zero');
  const dropdownRef = useRef(null);
  const handleToggle = index => {
    setSelectedUserIndex(index === SelectedUserIndex ? null : index);
  };

  const handleModalOpen = async _id => {
    const _user = users.find(u => u._id === _id); // Find the selected user by _id
    if (_user) {
      setSelectUser(_user); // Set the selected user
      setShowModal(true); // Open the modal
    }
    setSelectedUserIndex(null);
  };
  const handleUpdateModal = () => {
    setUpdateModalOpen(true);
  };

  const assignRole = id => {
    const _user = users.find(u => u._id == id);
    setRoles(_user?._roles?.map(u => u.role));
    setOpenRoleCreate(true);
    setIds(id);
  };
  const onAssignRoleToUser = async () => {
    try {
      if (roles.length == 0) {
        toast.success('Role is not selected yet');
        return;
      }
      const roleId = roles?.map(r => r._id);
      const { status, data } = await api.patch(`/user/updateRole/${ids}`, {
        roleId,
      });

      if (status == 201) {
        dispatch(updateUserSuccess(data.user));
        setOpenRoleCreate(false);
        getUserByAdmin();
        toast.success('Role assigned to user.');
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleDeleteUser = async id => {
    const updatedUsers = users?.filter(item => item?._id !== id);
    try {
      const { status } = await api.delete(`/user/deleteUser/${id}`);

      if (status == 200) {
        toast.success('User deleted successfully.');
        setUsers(updatedUsers);
        dispatch(userDeletedSuccess(id));

        setSelectedUserIndex(null);
      }
    } catch (error) {
      console.log(error, 'Err');
      toast.error(error?.response?.data?.message);
      setSelectedUserIndex(null);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState('');

  const confirmDeleteModal = async id => {
    setSelected(id);
    setShowDeleteModal(true);
    setSelectedUserIndex(null);
  };

  const confirmDelete = async () => {
    handleDeleteUser(selected);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedUserIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15; // Number of items per page

  const totalPages = Math.ceil(usersList?.length / itemsPerPage);

  // Get items for the current page
  const paginatedData = usersList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Handle next and previous page
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  return (
    <>
      <div className="w-full bg-white border border-gray-300 rounded-2xl overflow-hidden">
        <table className="w-full px-10">
          <thead className="bg-gray-200 h-12 text-left">
            <tr>
              <th className="ps-5">S. NO.</th>
              <th>User Name</th>
              <th>Phone No.</th>
              <th>Email</th>
              <th>Password</th>
              <th>
                <div className="flex gap-2 justify-center items-center">
                  Roles
                </div>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-left">
            {paginatedData?.map((user, index) => (
              <tr key={index} className="h-[6vh] border-b">
                <td className="ps-5">{index + 1}</td>
                <td>{`${user.firstName} ${user.lastName}`}</td>
                <td>{user.phone}</td>
                <td>{user.email}</td>
                <td>{user.password}</td>
                <td>
                  <div className="flex gap-2 justify-center items-center">
                    {user?._roles?.map((r, index) => (
                      <span key={index}>{r?.role?.name},</span>
                    ))}
                    <BsFillPencilFill
                      style={{ cursor: 'pointer', color: 'red' }}
                      onClick={() => assignRole(user?._id)}
                    />
                  </div>
                </td>
                <td className="relative" ref={dropdownRef}>
                  <Dropdown
                    menu={{
                      items: [
                        {
                          icon: <BsFillPencilFill />,
                          label: 'Edit',
                          key: '1',
                          onClick: () => handleModalOpen(user._id),
                        },
                        {
                          icon: <BsFillTrashFill />,
                          label: 'Delete',
                          key: '3',
                          onClick: () => confirmDeleteModal(user._id),
                        },
                      ],
                    }}
                  >
                    <HiDotsVertical
                      size={30}
                      className="cursor-pointer"
                      // onClick={() => handleToggle(index)}
                    />
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="my-5 flex justify-between items-center px-16 py-4">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className={`flex items-center space-x-3 ${
              currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <FaArrowLeft />
            <span>Prev</span>
          </button>
          <span className="font-semibold">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`flex items-center space-x-3 ${
              currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <span>Next</span>
            <FaArrowRight />
          </button>
        </div>
        {showModal && (
          <ViewUserModal
            getUserByAdmin={getUserByAdmin}
            showModal={showModal}
            setShowModal={setShowModal}
            selectUser={selectUser}
          />
        )}

        {updateModalOpen && (
          <UpdateUserModal
            updateModalOpen={updateModalOpen}
            setUpdateModalOpen={setUpdateModalOpen}
          />
        )}
      </div>

      {/* rendering roles here  */}
      <Modal
        isOpen={openRoleCreate}
        onRequestClose={() => setOpenRoleCreate(false)}
        contentLabel="Example Modal"
        style={{
          content: {
            width: '45%',
            height: '52%',
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="flex justify-between mx-5 my-3">
          <h1 className="text-2xl font-semibold">Assign Role</h1>
          <button onClick={() => setOpenRoleCreate(false)}>
            <IoMdCloseCircleOutline size={20} />
          </button>
        </div>
        <hr />
        <div className="h-[46dvh] w-[100%] flex flex-col justify-center items-center">
          <div className="h-[10dvh] w-[90%] flex justify-center flex-col">
            <p>Update Roles</p>

            <select
              className="p-2 w-full border rounded-lg text-sm outline-none my-1"
              id="assignProcedures"
              name="procedures"
              onChange={e => {
                const selectedRoleId = e.target.value;

                if (selectedRoleId !== 'zero') {
                  const selectedRole = _roles.find(
                    r => r && r._id === selectedRoleId
                  );

                  if (
                    selectedRole &&
                    !roles?.some(role => role?._id === selectedRoleId)
                  ) {
                    setRoles(prev => [...prev, selectedRole]);
                  } else {
                    toast.error('This role has already been added.');
                  }
                }
              }}
              value={selectedRoleId}
            >
              <option value="zero">--select role--</option>
              {_roles?.map(pro => (
                <option key={pro?._id} value={pro?._id}>
                  {pro?.name}
                  {roles?.some(role => role?._id === pro?._id) && ' (added)'}
                </option>
              ))}
            </select>
          </div>

          <div className="h-[50%] w-[90%] rounded-md">
            <h3>Role Selected</h3>
            <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
              {roles?.map((_pro, _index) => {
                return (
                  <div className="flex justify-between" key={_index}>
                    <p>{_pro?.name}</p>
                    <MdDelete
                      className="cursor-pointer"
                      onClick={() =>
                        setRoles(roles.filter(r => r?._id !== _pro?._id))
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="flex justify-end items-end self-end mx-5 my-3 gap-3">
            <button
              onClick={() => setOpenRoleCreate(false)}
              className="border border-red-500 p-1 px-5 rounded-lg"
            >
              Close
            </button>
            <button
              className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
              onClick={onAssignRoleToUser}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      {/* end */}

      {/* -- delete modal confirmation-- */}

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default UserTable;
